<template>
  <div class="header-container clearfix">
    <div class="logo">
      <logo />
    </div>
    <div class="user">
      <user />
    </div>
  </div>
</template>

<script>
import Logo from './Logo'
import User from './User'

export default {
  components: { Logo, User }
}
</script>

<style lang="less" scoped>
.header-container {
  .logo {
    float: left;
  }
  .user {
    float: right;
    padding-left: 80px;
  }
  .navbar {
    float: right;
  }
}
</style>